import React, { useState } from 'react';
import { Outlet, Navigate, useParams } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useTenant } from '../contexts/TenantContext';
import Sidebar from './Sidebar';

export default function Layout() {
  const { tenantSlug } = useParams();
  const { isAuthenticated } = useAuth();
  const { loading, error, branding } = useTenant();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-slate-50">
        <div className="animate-spin rounded-full h-10 w-10 border-4 border-[var(--brand-primary)] border-t-transparent" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center h-screen bg-slate-50">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-700 mb-2">Agência não encontrada</h1>
          <p className="text-gray-500">{error}</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={`/${tenantSlug}/login`} replace />;
  }

  const primaryColor = branding?.corPrimaria || '#0147a0';
  const nomeDoSistema = branding?.nomeDoSistema || 'Sistema Tour';

  return (
    <div className="flex min-h-screen bg-[#F0F4FF]">
      {/* Mobile overlay */}
      {sidebarOpen && (
        <div className="fixed inset-0 bg-black/50 z-20 lg:hidden" onClick={() => setSidebarOpen(false)} />
      )}

      {/* Sidebar */}
      <div className={`fixed inset-y-0 left-0 z-30 transform transition-transform duration-300 lg:translate-x-0 ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}`}>
        <Sidebar onClose={() => setSidebarOpen(false)} />
      </div>

      {/* Main content */}
      <div className="flex-1 flex flex-col min-w-0 lg:ml-64">
        {/* Mobile header */}
        <div className="lg:hidden flex items-center h-14 px-4 border-b border-blue-100"
          style={{ background: `linear-gradient(90deg, ${primaryColor}, ${primaryColor}cc)` }}>
          <button onClick={() => setSidebarOpen(true)} className="p-2 rounded-lg text-white/70 hover:bg-white/10">
            <Menu className="w-5 h-5 text-white" />
          </button>
          <span className="ml-3 font-bold text-white text-sm">{nomeDoSistema}</span>
        </div>

        <main className="flex-1 p-4 sm:p-6 lg:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
